<template>
	<div class="min-h-0">
		<app-title-bar :icon="['fas', 'fa-warehouse']" title="Yard Workspace">
			<div class="flex flex-col sm:flex-row sm:items-center gap-2">
				<depots-dropdown v-if="depot" v-model="depot" size="large" update-user required />
				<app-button icon="fa-arrows-rotate" @click="refresh++">Refresh</app-button>
			</div>
		</app-title-bar>

		<div>
			<div v-if="depot" class="w-full flex flex-col lg:flex-row gap-4 py-2">
				<yard-workspace-panel
					:key="depot + Math.random()"
					:refresh-trigger="refresh"
					title="Stock Check"
					area="stock-check"
					:depot="depot"
					route="yard-stock-item"
					view-all="/yard/stock-items" />

				<yard-workspace-panel
					:key="depot + Math.random()"
					:refresh-trigger="refresh"
					title="Pick / Load"
					area="pick"
					:depot="depot"
					route="yard-pick-item"
					view-all="/yard/pick-items" />

				<yard-workspace-panel
					:key="depot + Math.random()"
					:refresh-trigger="refresh"
					title="Journey"
					area="journey"
					:depot="depot"
					route="yard-journey-item"
					view-all="/yard/journey-items" />
			</div>

			<div v-if="depot" class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 py-2">
				<yard-workspace-panel
					:key="depot + Math.random()"
					:refresh-trigger="refresh"
					title="Collections"
					area="collections"
					:depot="depot"
					route="yard-collection-item"
					view-all="/yard/collection-items" />
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import DepotsDropdown from '@/components/partials/dropdowns/DepotsDropdown.vue'
	import { ref, onMounted } from 'vue'
	import useAuthStore from '@/stores/auth'
	import YardWorkspacePanel from '@/components/partials/panels/YardWorkspacePanel.vue'

	// Resources
	const auth = useAuthStore()

	// Data
	const depot = ref<string | null>(null)
	const refresh = ref(0)

	onMounted(() => {
		if (auth.user && auth.user.current_depot) {
			depot.value = auth.user.current_depot
		}
	})
</script>
